module.exports = __webpack_public_path__ + "img/info_event.ef36a4e3.svg";